import { render, staticRenderFns } from "./LeadNotAddressed.vue?vue&type=template&id=63d77208&scoped=true&"
import script from "./LeadNotAddressed.vue?vue&type=script&lang=js&"
export * from "./LeadNotAddressed.vue?vue&type=script&lang=js&"
import style0 from "./LeadNotAddressed.vue?vue&type=style&index=0&id=63d77208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d77208",
  null
  
)

export default component.exports